import { ComponentPropsWithoutRef, FC } from 'react';
type FileCabinetIcon = ComponentPropsWithoutRef<'svg'>;
export const FileCabinetIcon: FC<FileCabinetIcon> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M13.6875 1H2.3125C1.58762 1 1 1.58762 1 2.3125V13.6875C1 14.4124 1.58762 15 2.3125 15H13.6875C14.4124 15 15 14.4124 15 13.6875V2.3125C15 1.58762 14.4124 1 13.6875 1ZM14.125 13.6875C14.125 13.9287 13.9287 14.125 13.6875 14.125H2.3125C2.07133 14.125 1.875 13.9287 1.875 13.6875V8.4375H14.125V13.6875ZM14.125 7.5625H1.875V2.3125C1.875 2.07133 2.07133 1.875 2.3125 1.875H13.6875C13.9287 1.875 14.125 2.07133 14.125 2.3125V7.5625ZM10.1875 3.625H5.8125C5.57078 3.625 5.375 3.82078 5.375 4.0625V5.15625C5.375 5.27711 5.47289 5.375 5.59375 5.375H6.03125C6.15211 5.375 6.25 5.27711 6.25 5.15625V4.5H9.75V5.15625C9.75 5.27711 9.84789 5.375 9.96875 5.375H10.4062C10.5271 5.375 10.625 5.27711 10.625 5.15625V4.0625C10.625 3.82078 10.4292 3.625 10.1875 3.625ZM5.59375 12.375H6.03125C6.15211 12.375 6.25 12.2771 6.25 12.1562V11.5H9.75V12.1562C9.75 12.2771 9.84789 12.375 9.96875 12.375H10.4062C10.5271 12.375 10.625 12.2771 10.625 12.1562V11.0625C10.625 10.8208 10.4292 10.625 10.1875 10.625H5.8125C5.57078 10.625 5.375 10.8208 5.375 11.0625V12.1562C5.375 12.2771 5.47289 12.375 5.59375 12.375Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
